import React from "react";
import { CSSTransition } from "react-transition-group";
import { formatLocationAddress } from "../../obp/utils";
import LocationDetails from "./LocationDetails";

export default function LocationItem({
  sectionData,
  location,
  openedLocation,
  onOpenedLocation,
}) {
  const detailsTransitionDuration = 300;

  return (
    <div className="location">
      <h3 className="location__title h-lg-sans text-color-black">
        {location.name}
      </h3>
      <div className="location__address font-body-md">
        {formatLocationAddress(location, false).join(", ")}
        {location.phone && (
          <>
            <br />
            <a href={"tel:" + location.phone}>{location.phone}</a>
          </>
        )}
        {location.email && (
          <>
            <br /> <a href={"mailto:" + location.email}>{location.email}</a>
          </>
        )}
      </div>
      {location.badges?.length > 0 && (
        <div className="location__badges">
          {location.badges.map((label, i) => {
            return (
              <div key={label + i} className="location__badge">
                {sectionData?.checkmarkSVG && (
                  <span
                    className="location__badge-icon"
                    dangerouslySetInnerHTML={{
                      __html: sectionData.checkmarkSVG,
                    }}
                  ></span>
                )}
                {label}
              </div>
            );
          })}
        </div>
      )}

      <div className="location__buttons">
        <a
          className="location__direction location__link"
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            `${location.latitude},${location.longitude}`
          )}`}
          target="_blank"
        >
          {sectionData?.locationPinSVG && (
            <span
              className="location__link-icon"
              dangerouslySetInnerHTML={{ __html: sectionData.locationPinSVG }}
            ></span>
          )}
          Get directions
        </a>

        {location.website && (
          <a className="location__link" href={location.website} target="_blank">
            {sectionData?.websiteSVG && (
              <span
                className="location__link-icon"
                dangerouslySetInnerHTML={{ __html: sectionData.websiteSVG }}
              ></span>
            )}
            Visit website
          </a>
        )}
      </div>

      <button
        type="button"
        className={"location-details__trigger location__link".concat(
          openedLocation?.id == location.id ? " active" : ""
        )}
        onClick={() => onOpenedLocation(location)}
      >
        View details
        {sectionData?.linkChevronSVG && (
          <span
            className="location-details__trigger-icon"
            dangerouslySetInnerHTML={{ __html: sectionData.linkChevronSVG }}
          ></span>
        )}
      </button>

      <CSSTransition
        in={openedLocation?.id == location.id}
        mountOnEnter={true}
        unmountOnExit={true}
        timeout={detailsTransitionDuration}
        onEnter={(node) => {
          node.style.height = 0;
        }}
        onEntering={(node) => {
          node.style.height = `${node.scrollHeight}px`;
        }}
        onEntered={(node) => {
          node.style.height = "";
        }}
        onExit={(node) => {
          node.style.height = `${node.scrollHeight}px`;
        }}
        onExiting={(node) => {
          node.style.height = 0;
        }}
      >
        <LocationDetails location={location} />
      </CSSTransition>
    </div>
  );
}
